/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import { Document, Page, pdfjs } from 'react-pdf';
import { ButtonWithIcon } from '@vlinder-web/button-v2-widget-react';
import { Navbar, Button, ButtonGroup, Container } from 'react-bootstrap';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import * as S from './styles';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export interface IPdfViewerProps {
  file: string;
  title?: string;
  onPdfClose?(): void;
  closeTitleLabel?: string;
  maxPageWidth?: number;
  loadingPdfTitle?: string;
  loadingPdfIllustration?: string;
  loadingPdfDescription?: string;
}

export const PdfViewer = ({
  file,
  title,
  onPdfClose,
  closeTitleLabel,
  maxPageWidth,
  loadingPdfTitle,
  loadingPdfIllustration,
  loadingPdfDescription,
}: IPdfViewerProps) => {
  const { width } = useViewport();
  const [numPages, setNumPages] = React.useState(null);
  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
  }

  const PdfLoadingComp = () => {
    return (
      <div style={{ backgroundColor: '#fff', width: width, height: '100vh' }}>
        <StateOSD
          image={loadingPdfIllustration}
          titleNormalText={loadingPdfTitle}
          titleBoldText={''}
          description={loadingPdfDescription}
        />
      </div>
    );
  };

  return (
    <>
      {file && (
        <>
          <Navbar
            variant="dark"
            bg="dark"
            fixed={'top'}
            className="navbar-transparent navbar-theme-primary"
          >
            <Container className="position-relative justify-content-between px-3">
              {title ? (
                <Navbar.Brand>
                  <span>{title}</span>
                </Navbar.Brand>
              ) : (
                <div />
              )}
              <div className="d-block mb-4 mb-md-0 justify-content-end">
                <ButtonGroup className="ms-2 ms-lg-3 p-sm-2 p-md-3">
                  <ButtonWithIcon
                    title={closeTitleLabel}
                    icon={'XIcon'}
                    iconPosition={'left'}
                    onClick={onPdfClose}
                    className="bg-secondary"
                  />
                </ButtonGroup>
              </div>
            </Container>
          </Navbar>
          <div style={S.DocumentContainer}>
            <Document
              file={file}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={PdfLoadingComp}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  width={Math.min(width, maxPageWidth ?? 800)}
                />
              ))}
            </Document>
          </div>
        </>
      )}
    </>
  );
};

PdfViewer.defaultProps = {
  closeTitleLabel: '',
  maxPageWidth: 800,
  loadingPdfTitle: 'Loading PDF Document',
  loadingPdfIllustration:
    'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/bc_verificaiton_illustration.png',
  loadingPdfDescription: 'This might take few seconds, Please wait !',
};
